<script>
import BaseContainer from "./BaseContainer.vue";
export default {
  extends: BaseContainer,
  data() {
    return {
      position: "timer",
      allow: ["timer"]
    };
  },
  computed: {
    canAddElement() {
      if (this.components.find(c => c.type == "timer")) return false;
      return (
        window.innerWidth < 992 ||
        (this.element && this.allow.includes(this.element))
      );
    },
    _components() {
      return this.components.filter(c => c.type == "timer");
    }
  },
  methods: {
    saveComponent(component) {
      const components = [...this.components];
      const index = components.findIndex(c => c.type == "timer");
      if (index > -1) {
        components[index] = { ...this.activeComponent, ...component };
      } else {
        components.push({ ...component, type: "timer" });
      }

      this.$store.dispatch("checkoutBuilder/saveSnapshot");
      this.$store.commit("checkoutBuilder/setComponents", components);

      this.modal = false;
    },
    removeComponent() {
      const components = [...this.components].filter(c => c.type != "timer");

      this.$store.dispatch("checkoutBuilder/saveSnapshot");
      this.$store.commit("checkoutBuilder/setComponents", components);
    }
  }
};
</script>
